import PropTypes from "prop-types";

export const DATE_FORMAT_FOR_API = "YYYY-MM-DD";

export const deadlinesScope = {
  Fiscale: "fiscal_social_security"
};

export const deadlinesTypes = {
  FiscalePianificate: "fiscale_pianificate",
  FiscaleEffettiva: "fiscale_effettiva",
  Altro: "altro"
};

export const deadlinesFilters = [
  {
    label: "Autorizzato",
    type: "status",
    value: "authorized"
  },
  {
    label: "Non autorizzato",
    type: "status",
    value: "rejected"
  },
  {
    label: "Da pagare",
    type: "status",
    value: "to_be_paid"
  },
  {
    label: "Da incassare",
    type: "status",
    value: "to_be_collected"
  },
  {
    label: "Non pagato",
    type: "status",
    value: "unpaid"
  },
  {
    label: "Pagata",
    type: "status",
    value: "paid"
  },
  {
    label: "In pagamento",
    type: "status",
    value: "pending"
  },
  {
    label: "Incassata",
    type: "status",
    value: "collected"
  },
  {
    label: "Sospesa",
    type: "status",
    value: "suspended"
  },
  {
    label: "Abbuonato",
    type: "status",
    value: "rebated"
  }
];

export const monthsList = [
  { value: 0, text: "Gennaio" },
  { value: 1, text: "Febbraio" },
  { value: 2, text: "Marzo" },
  { value: 3, text: "Aprile" },
  { value: 4, text: "Maggio" },
  { value: 5, text: "Giugno" },
  { value: 6, text: "Luglio" },
  { value: 7, text: "Agosto" },
  { value: 8, text: "Settembre" },
  { value: 9, text: "Ottobre" },
  { value: 10, text: "Novembre" },
  { value: 11, text: "Dicembre" }
];

export const deadLinePropType = PropTypes.shape({
  id: PropTypes.string,
  itemId: PropTypes.string,
  managerId: PropTypes.string,
  type: PropTypes.string,
  scope: PropTypes.string,
  description: PropTypes.shape({
    title: PropTypes.string,
    details: PropTypes.string
  }),
  itemDetails: PropTypes.shape({
    description: PropTypes.string,
    taxRegime: PropTypes.string
  }),
  date: PropTypes.string,
  status: PropTypes.shape({
    confirmed: PropTypes.bool,
    viewed: PropTypes.bool,
    archived: PropTypes.bool
  }),
  totalAmount: PropTypes.number,
  attachments: PropTypes.array,
  payment: PropTypes.shape({
    type: PropTypes.oneOf(["item_pays", "manager_pays", "manager_charge"]),
    choice: PropTypes.oneOf(["due", "unpaid", "not_paying"])
  })
});

export function getTypeByDeadline(deadline) {
  if (deadline?.scope === deadlinesScope?.Fiscale) {
    if (deadline?.status?.confirmed === true) {
      return deadlinesTypes.FiscaleEffettiva;
    } 
    return deadlinesTypes.FiscalePianificate;
    
  } 
  return deadlinesTypes.Altro;
  
}

export function classByDeadline(deadline) {
  if (getTypeByDeadline(deadline) === deadlinesTypes.FiscalePianificate) {
    return "eventType2";
  }
  return deadline.totalAmount > 0 ? "eventType1" : "eventTypeDefault";
}

export function getSafeValueString(object, key) {
  let value = "";
  if (object && object[key]) {
    value = object[key].trim();
  }

  return value;
}

export function scrollToWithAnimation(
  elementToScroll, to = 0, duration = 1000, scrollToDone = null
) {
  const start = elementToScroll.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = () => {
    currentTime += increment;

    const val = Math.easeInOutQuad(
      currentTime, start, change, duration
    );

    elementToScroll.scrollTo(0, val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else {
      if (scrollToDone) scrollToDone();
    }
  };

  animateScroll();
}

Math.easeInOutQuad = function(
  t, b, c, d
) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};
